import { render, staticRenderFns } from "./TempConfigCostItemList.vue?vue&type=template&id=21922ff1&scoped=true"
import script from "./TempConfigCostItemList.vue?vue&type=script&lang=js"
export * from "./TempConfigCostItemList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigCostItemList.vue?vue&type=style&index=0&id=21922ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21922ff1",
  null
  
)

export default component.exports